import { Text } from "@primer/react";
import { TagIcon } from "@primer/octicons-react";
import "../IdentityLink/IdentityLink.css";
import "./PropertyValueIdentity.css";

export function propertyValueHref(propertyId, valueId) {
  return `#/properties/${encodeURIComponent(propertyId)}/${encodeURIComponent(valueId)}`;
}

export function PropertyValueIdentity({ href, property, propertyHref, value, variant = "compact" }) {
  if (propertyHref) {
    return <span className={`${variant} property-value-identity`}><TagIcon aria-hidden="true" /><span className="property-value-label"><a className="identity-link property-value-link" href={href}><strong className="identity-link-label">{value.name}</strong></a> <a className="identity-link property-key-link" href={propertyHref}><Text as="span" className="identity-link-label">{property.name}</Text></a></span></span>;
  }
  const Target = href ? "a" : "span";
  return <Target className={`${variant} identity-link property-value-identity`} href={href}><TagIcon aria-hidden="true" /><span className="identity-link-label property-value-label"><strong className="identity-link-part">{value.name}</strong> <Text as="span" className="identity-link-part">{property.name}</Text></span></Target>;
}
